import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgReviewsCardSkeleton = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 842 200"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width={842} height={200} rx={8} fill="#fff" />
    <path
      fill="#E6E9ED"
      d="M16 35h140v1H16zM65 67h80v1H65zM65 84h150v1H65zM16 148h484v1H16zM16 178h150v1H16zM16 116h806v1H16zM16 132h742v1H16z"
    />
    <circle cx={36} cy={72} r={20} fill="#E6E9ED" />
  </svg>
);
const Memo = memo(SvgReviewsCardSkeleton);
export default Memo;
